import { useState } from 'react'
import axios from 'axios'
import { useCookies } from 'react-cookie'
import { api } from '../../common/api'
import { ACCESS_TOKEN } from '../../common/util' 

type Club = {
    content: ClubData[];
    number: number;
    totalElements: number;
}

export type ClubData = {
    academyId: number
    academyAddress: string
    academyName: string
    active: boolean
    appliedDate: string
    academyImageUrl: string
}

export default function useGetClubsActive() {
    const baseUrl = api.base_url
    const [cookies] = useCookies([ACCESS_TOKEN])
    const [activeClubSearchResults, setActiveClubSearchResults] = useState<Club | null>()
    const [clubError, setClubError] = useState('')

    const getClubsActive = async (search: string, pageNum?: number, isPaid?:string) => {
        const pageValue = pageNum ? (pageNum - 1) : 0;

        try {
            const response = await axios(`${baseUrl}/academy/admin-simple-in-app?in-app=${isPaid}&page=${pageValue}&size=8&searchValue=${search}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${cookies[ACCESS_TOKEN]}`
                }
            })
            setActiveClubSearchResults(response.data.data)
        } catch (err) {
            console.error((err as Error).message)
            setClubError((err as Error).message)
        }
    }
    
    return { getClubsActive, clubError, activeClubSearchResults, setActiveClubSearchResults }
}